import React from "react";

function LiquidGlass({ children, className = "", style = {} }) {
  return (
    <div
      className={`glass-panel ${className}`.trim()}
      style={{
        padding: 12,
        borderRadius: "var(--glass-radius)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default LiquidGlass;

